import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslateModule} from '@ngx-translate/core';
import {FieldComponent} from '../field/field.component';

@Component({
    selector: "woa-phone-number-field",
    templateUrl: "./phone-number-field.component.html",
    styleUrl: "./phone-number-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: PhoneNumberFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneNumberFieldComponent extends AbstractField {
    public readonly autocomplete: InputSignal<"mobile" | "username"> = input<"mobile" | "username">("mobile");

    public validateCharacter(event: KeyboardEvent): void {
        if (["Backspace", "ArrowLeft", "ArrowRight", "Tab", "+", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(event.key) == -1) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    public correctInput(event: KeyboardEvent): void {
        event.target["value"] = event.target["value"].replace(/[^+\d]/g, "").replace(/(.+)\+/g, "$1");
    }
}
